import React from "react";
import banner from "../../img/banner.jpg";

export default function Slider() {
  return (
    <>
      <div className="relative">
        <div className="relative h-56 overflow-hidden md:h-[35rem]">
          <div className="duration-200 ease-linear absolute inset-0 transition-all transform">
            <img
              src={banner}
              className="absolute block w-full -translate-x-1/2 -translate-y-1/2 top-1/2 left-1/2"
              alt="slider"
            />
          </div>
        </div>
      </div>
    </>
  );
}
